import type {
  IDemo,
  OrganizationPlan,
  Playbook,
  Tour,
  Workspace,
} from '@carboncopyco/types';
import { DashboardBody } from './DashboardBody';
import { DashboardProvider } from './DashboardContext';
import { DashboardHeader } from './DashboardHeader';

export type DashboardProps = {
  organizationId: string;
  planId: OrganizationPlan;
  goToDemo: (demoId: IDemo['id'], workspaceId: string) => void;
  goToDemoPreview: ({
    id,
    firstUrl,
    workspaceId,
  }: {
    id: IDemo['id'];
    firstUrl: string;
    workspaceId: string;
  }) => void;
  goToTour: (tourId: Tour['id'], workspaceId: Workspace['id']) => void;
  demoPagePath: (demoId: string, workspaceId: Workspace['id']) => string;
  tourPagePath: (tourId: string, workspaceId: Workspace['id']) => string;
  playbookPagePath: (
    playbookId: Playbook['id'],
    workspaceId: Workspace['id']
  ) => string;
  goToArchivedDemoPreview: (
    params: Pick<IDemo, 'id' | 'firstUrl' | 'playerToken' | 'workspaceId'>
  ) => void;
  goToTourPreview: (tourId: Tour['id'], workspaceId: string) => void;
  goToPlaybook: (
    playbookId: Playbook['id'],
    workspaceId: Workspace['id']
  ) => void;
};

export const Dashboard = (props: DashboardProps) => {
  return (
    <DashboardProvider {...props}>
      <DashboardHeader />
      <div className="flex justify-center overflow-hidden bg-ds-natural-50 w-full">
        <DashboardBody />
      </div>
    </DashboardProvider>
  );
};
